import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: ["Poppins", "Axiata-Bold", "Axiata-Medium"].join(","),
  },
});

export { theme };
